import actions from "./componentActions"
import showModal from "./showModal"
import cssVars from "./cssVars"
import scrollTo from './scrollTo';

export const applyMixins = (app) => {
  app.mixin(actions)
  app.mixin(showModal)
  app.mixin(cssVars)
  app.mixin(scrollTo)
}